import { render } from "./Drawer.vue?vue&type=template&id=e7e1edbc&ts=true"
import script from "./Drawer.vue?vue&type=script&lang=ts"
export * from "./Drawer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__